import { connect } from 'react-redux';

import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { ContentInfoCardChannel, ContentInfoChannelOwnProps, ContentInfoChannelProps } from '../../../home/components/ContentInfoCardChannel';
import { ChannelTypes } from '../../../home/types/ChannelTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export const ConnectedSharedWithMeChannel = connect((state: AppState, props: ContentInfoChannelOwnProps) => {
    const siteUrls = siteUrlsSelector(state);

    let list: IContentInfo[] = [];

    state.home.sharedWithMe.items.forEach((contentId: string) => {
      list.push(state.normalizedContentById[contentId]);
    });

    const channelProps: ContentInfoChannelProps = {
        channelType: ChannelTypes.sharedWithMe,
        title: Messages.sharedWithMeTitle(),
        seeAllUrl: siteUrls.sharedWithMeUrl(),
        seeAllAltText: Messages.sharedWithMeSeeAllAltText(),
        list,
        isFetching: state.home.sharedWithMe.isFetching,
        numRows: 2,
        maxCardsPerRow: props.maxCardsPerRow,
        spaceInfo: selectSpaceInfo(state)
    };

    return channelProps;
})(ContentInfoCardChannel);
